import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Loader2 } from "lucide-react";
import { trustLogin, apiErr } from "@/lib/api";

export const PasswordGate = ({ onUnlock }) => {
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    if (!pw.trim() || loading) return;
    setLoading(true);
    setError("");
    try {
      await trustLogin(pw);
      onUnlock();
    } catch (err) {
      setError(apiErr(err, "Hatalı şifre"));
      setPw("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="trust-root min-h-[100svh] w-full flex flex-col items-center justify-center bg-[#050505] relative overflow-hidden px-6"
      data-testid="trust-password-gate"
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 42%, rgba(74,14,23,0.55) 0%, rgba(5,5,5,0) 70%)",
        }}
      />
      <div className="trust-grain pointer-events-none absolute inset-0 opacity-[0.05]" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 w-full max-w-xl flex flex-col items-center text-center"
      >
        <span className="font-mono text-[10px] sm:text-xs tracking-[0.45em] text-[#C48A5E] uppercase mb-8">
          Ertan Kasap
        </span>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#F5F5F0] mb-3">
          Marka Güven Merkezi
        </h1>
        <p className="font-mono text-[11px] sm:text-xs tracking-[0.25em] text-[#A3A09A] uppercase mb-14">
          Özel Erişim · Güven İnşa Sistemi
        </p>

        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="relative flex items-center">
            <input
              data-testid="trust-password-input"
              type="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              autoFocus
              placeholder="Güven Şifresi"
              className="w-full bg-transparent border-b border-[#C48A5E]/30 focus:border-[#C48A5E] outline-none text-center text-2xl sm:text-3xl font-serif text-[#F5F5F0] placeholder:text-[#A3A09A]/40 pb-3 transition-colors"
            />
            <button
              type="submit"
              data-testid="trust-password-submit"
              disabled={loading}
              aria-label="Giriş"
              className="absolute right-0 text-[#C48A5E] hover:translate-x-1 transition-transform disabled:opacity-50"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                <ArrowRight className="w-5 h-5" />
              )}
            </button>
          </div>
          {error && (
            <p
              data-testid="trust-password-error"
              className="mt-4 font-mono text-xs tracking-wider text-[#E5687A]"
            >
              {error}
            </p>
          )}
        </form>
      </motion.div>
    </div>
  );
};

export default PasswordGate;
